// API Configuration - handles both local development and Vercel deployment
const getApiUrl = () => {
  // In Vercel, API routes are served from the same origin
  // In local development, use localhost:3001
  if (typeof window !== 'undefined') {
    // Browser environment
    if (process.env.NODE_ENV === 'production' || window.location.hostname !== 'localhost') {
      // Production/Vercel - use same origin
      return '';
    } else {
      // Local development
      return process.env.REACT_APP_API_URL || 'http://localhost:3001';
    }
  }
  // Server-side rendering
  return process.env.REACT_APP_API_URL || 'http://localhost:3001';
};

export const API_BASE_URL = getApiUrl();

// Helper function to build API URLs
export const buildApiUrl = (endpoint) => {
  const base = API_BASE_URL;
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return base ? `${base}${cleanEndpoint}` : `/api${cleanEndpoint}`;
};

export default API_BASE_URL;
